"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var context_1 = require("../../../core/context");
exports.CONTEXT_STATE_ASSIGNMENTS = 'CONTEXT_STATE_ASSIGNMENTS';
exports.contextState = function (contextName) {
    // activate standard context behaviour
    var contextHanderFn = context_1.context(contextName);
    return function (prototype, propName) {
        if (!prototype[exports.CONTEXT_STATE_ASSIGNMENTS]) {
            prototype[exports.CONTEXT_STATE_ASSIGNMENTS] = [];
        }
        // remember context name to add a change listener later
        // before after initial render
        prototype[exports.CONTEXT_STATE_ASSIGNMENTS].push(contextName);
        // actually initialize the context state
        return contextHanderFn(prototype, propName);
    };
};
//# sourceMappingURL=context-state.js.map